// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/techniconcept-projects." + "3687a94f" + ".chunk.js";
};